/**
 * CDMX Scripts 2022
 * Components Scripts
 */

// Toggle animation for Dropdown menu

$('.Cdmx-app-ciudadano-hamburger-bullet').on('click', function(e) {
    if ($('.Cdmx-app-ciudadano-hamburger-container').is(':visible')) {
        $('.Cdmx-app-ciudadano-hamburger-container').hide();
    } else {
        $('.Cdmx-app-ciudadano-hamburger-container').show();
    }
});
